/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Base-Serializer for all user types. Deprecated note: Do not use this serializer
 * directly but, the user type specific serializer, e.g. OrgUserSerializer,
 * GuestUserSerializer.
 * @export
 * @interface APIPatchedAllInOneUserRequest
 */
export interface APIPatchedAllInOneUserRequest {
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof APIPatchedAllInOneUserRequest
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAllInOneUserRequest
     */
    comment?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIPatchedAllInOneUserRequest
     */
    createdAt?: Date;
    /**
     * 
     *             <ul style="list-style=none;">
     *                 <li>Required for organization users, as the email is used as the username.</li>
     *                 <li>Guest users do *not* require an email address.</li>
     *             </ul>
     *             
     * @type {string}
     * @memberof APIPatchedAllInOneUserRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPatchedAllInOneUserRequest
     */
    repFor?: string;
}

/**
 * Check if a given object implements the APIPatchedAllInOneUserRequest interface.
 */
export function instanceOfAPIPatchedAllInOneUserRequest(value: object): value is APIPatchedAllInOneUserRequest {
    return true;
}

export function APIPatchedAllInOneUserRequestFromJSON(json: any): APIPatchedAllInOneUserRequest {
    return APIPatchedAllInOneUserRequestFromJSONTyped(json, false);
}

export function APIPatchedAllInOneUserRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedAllInOneUserRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'email': json['email'] == null ? undefined : json['email'],
        'repFor': json['rep_for'] == null ? undefined : json['rep_for'],
    };
}

export function APIPatchedAllInOneUserRequestToJSON(value?: APIPatchedAllInOneUserRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'is_active': value['isActive'],
        'comment': value['comment'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'email': value['email'],
        'rep_for': value['repFor'],
    };
}

